import '@babel/polyfill'
import 'intersection-observer'
import WebFont from 'webfontloader'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import imageLoader from './plugins/imageLoader/index.js'
import SmoothScrollbar from './plugins/vue-smooth-scrollbar/index.js'

WebFont.load({
  google: {
    families: ['Montserrat:300,600']
  },
  custom: {
    families: ['SangBleu Republic', 'Montserrat'],
    urls: ['/assets/css/font-face.css']
  }
})

Vue.config.productionTip = false
Vue.use(imageLoader)
Vue.use(SmoothScrollbar)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
